import React from 'react';
import QaqcRfiFormCreate from './QaqcRfiFormCreate';

const QaqcRfiFormEdit: React.FC = () => {
  return <QaqcRfiFormCreate mode="edit" />;
};

export default QaqcRfiFormEdit;
